import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class labelMultiSelectListCtrl implements IController {
  selectedLabelNames: any;
  ngPlaceholder: any;
  onChange: Function;

  private labelsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $labels, private $infiniteScroll, private $log, private commonsService: CommonsService) {
  }

  $onInit() {
    this.labelsRef = this.$labels();
    this.loadLimit = 20;

    this.labelsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.labelsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedLabelNames) {
      this.selectedKeys = [];
      _.forEach(this.selectedLabelNames, (id) => {
        this.selectedKeys[id] = true;
      })
    }
  }

  onToggle(label, isSelected) {
    this.onChange({
      labelNames: isSelected ? _.concat(this.selectedLabelNames, [label]) :
        _.filter(this.selectedLabelNames,(id) => {
          return id !== label;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({labelNames: []});
    } else {
      this.onChange({labelNames: this.infiniteScroll?.getItems()?.map((label) => label.name)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(label => label.name), this.selectedLabelNames);
    return this.isSelectAll;
  }

  private _reload() {
    this.labelsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      sort: 'name,asc'
    };
  }

}

angular
    .module('bringoz.admin.labels')
    .component('labelMultiSelectList', {
        bindings: {
          selectedLabelNames: '<',
          ngPlaceholder: '@?',
          onChange: '&'
        },
        template: require('./label-multi-select-list.html').default,
        controller: labelMultiSelectListCtrl
    });
